import { MuiPickersAdapterContext } from '@mui/x-date-pickers-pro';
import { useContext, useCallback, useMemo } from 'react';

const FORMAT_KEY = 'fullDate';

export const useDateAdapterUtils = () => {
  const localization = useContext(MuiPickersAdapterContext);
  /**
   * As each date adapter (e.g. date-fns, dayjs, etc.) has its own set of utility functions,
   * and the date object is different for each adapter, we need to adapt the different day utils
   * directly from the adapter itself and not from the day object in order to prevent errors.
   */
  const utilsFunctionsByDateAdapter = localization.utils;

  // We format the date according to the adapter that was passed to us in LocalizationProvider
  const format = useCallback(
    date => utilsFunctionsByDateAdapter.format(date, FORMAT_KEY),
    [utilsFunctionsByDateAdapter]
  );

  const dateAdapterUtils = useMemo(
    () => ({
      ...utilsFunctionsByDateAdapter,
      format
    }),
    [utilsFunctionsByDateAdapter, format]
  );

  return dateAdapterUtils;
};
